<template>
    <div
        :style="componentStyles"
        class="o-building-labels"
    >
        <MapLabel
            v-for="building in anchorBuildings"
            :key="building.id"
            :selectedUnit="building.floor.unit_name"
            target="floor"
            :offsetX="0"
            :offsetY="27"
            position-x="left"
            position-y="bottom"
        >
            <ADialog
                icon="marker"
                :fill="getOutdoorViewConfig('labels.buildings.marker.color','')"
                :cursorPointer="getOutdoorViewConfig('events.cover_click', false)"
                @click="onBuildingClick(building.meta.building_index)"
            >
                {{ t(building, 'name') }}
            </ADialog>
        </MapLabel>
        <MapLabel
            v-for="building in buildingsWithUnitPosition"
            :key="building.id"
            :selectedUnit="building.unit.name"
            target="unit"
            :offsetX="0"
            :offsetY="27"
            position-x="left"
            position-y="bottom"
        >
            <ADialog
                icon="marker"
                :fill="getOutdoorViewConfig('labels.buildings.marker.color','')"
                :cursorPointer="getOutdoorViewConfig('events.cover_click', false)"
                @click="onBuildingClick(building.meta.building_index)"
            >
                {{ t(building, 'name') }}
            </ADialog>
        </MapLabel>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ADialog from "@/components/atoms/a-dialog/a-dialog";
import MapLabel from "../../../shared/components/map-viewer/labels/map-label";

export default {
    name: "OBuildingLabels",
    components: {
        ADialog,
        MapLabel
    },
    props: {
        buildings: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp'
        ]),
        anchorBuildings(){
            return this.buildings.filter( o => o.meta.anchor && !this.buildingsWithUnitPosition.some(({id}) => id == o.id));
        },
        buildingsWithUnitPosition() {
            return this.buildings.filter(building => {
                const buildindFloorName = building?.floor?.unit_name;
                const buildindUnitName = building?.unit?.name;

                return buildindFloorName !== buildindUnitName;
            })
        },
        componentStyles() {
            return this.getMapConfigProp('components.OBuildingLabels.styles') || {};
        },
        componentParams() {
            return this.getMapConfigProp('components.OBuildingLabels.params') || {};
        }
    },
    methods: {
        onBuildingClick(data) {
            this.$emit('buildingClick', data)
        },
        getOutdoorViewConfig(prop, def){
            return this.getMapConfigProp(`map_views.outdoor.${prop}`) || this.getMapConfigProp(`map_views.default.${prop}`, def);
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>